import { useMemo } from 'react';
import { LIST_TYPES } from 'Common/enums';

function useGetSortedLists(listData?: ListApiGetResponse, parameterType?: string) {
    const [listsTypePan, listsTypeRange, listsTypeGen] = useMemo(() => {
        const listTypePan: ListManagementApiList[] = [];
        const listTypeGen: ListManagementApiList[] = [];
        const listTypeRange: ListManagementApiList[] = [];
        listData?.result.forEach((list: ListManagementApiList) => {
            if (list.listType === LIST_TYPES.PAN) {
                listTypePan.push(list);
            } else if (list.listType === LIST_TYPES.RANGE) {
                listTypeRange.push(list);
            } else {
                listTypeGen.push(list);
            }
        });
        return [listTypePan, listTypeRange, listTypeGen];
    }, [listData]);

    let sortedListsByType: ListManagementApiList[] = parameterType === LIST_TYPES.PAN ? listsTypePan : listsTypeGen;
    if (parameterType === 'NUMBER') {
        sortedListsByType = sortedListsByType.concat(listsTypeRange);
    }
    return { sortedListsByType };
}

export default useGetSortedLists;
